"use client";

import { c as _c } from "react/compiler-runtime";
import { initializeMessaging } from "@/fire-store";
import useNotificationStore from "@/store/notification-store";
import { FCMNotificationPayload } from "@/types/fcm-notification-type";
import { useQueryClient } from "@tanstack/react-query";
import { MessagePayload, onMessage } from "firebase/messaging";
import Image from "next/image";
import { useEffect } from "react";
import { Toaster, toast } from "react-hot-toast";
import NotificationIcon from "../public/icons8-notification.gif";
const Notification = () => {
  const $ = _c(18);
  const queryClient = useQueryClient();
  const {
    addNotification,
    addUserMessagesNotification,
    setSelectedConversationId,
    setIsMessagesSheetOpen,
    addUserNotification,
    addNotRemovedNotifications,
    removeSupportNotifications,
    addUnReadCounter
  } = useNotificationStore();
  const parseNormalUser = _temp;
  let t0;
  if ($[0] !== addNotRemovedNotifications || $[1] !== addNotification || $[2] !== addUnReadCounter || $[3] !== addUserMessagesNotification || $[4] !== addUserNotification || $[5] !== queryClient || $[6] !== removeSupportNotifications || $[7] !== setIsMessagesSheetOpen || $[8] !== setSelectedConversationId) {
    t0 = () => {
      if ("serviceWorker" in navigator) {
        navigator.serviceWorker.register("/firebase-messaging-sw.js").then(_temp2).catch(_temp3);
      }
      const fireBaseFunction = async () => {
        const messagingInstance = await initializeMessaging();
        if (!messagingInstance) {
          return;
        }
        onMessage(messagingInstance, payload => {
          const conversationId = parseInt(payload?.data?.conversation_id || "0");
          console.log(conversationId, "hello ??");
          queryClient.invalidateQueries({
            queryKey: ["user-message", conversationId]
          });
          console.log("user-message", conversationId, "from notf");
          queryClient.invalidateQueries({
            queryKey: ["messages"]
          });
          const typedPayload = payload as FCMNotificationPayload;
          console.log("Full payload:", payload);
          console.log("Payload notification:", payload.notification);
          console.log("Payload data:", payload.data);
          console.log("Data type:", payload.data?.type);
          if (payload.data?.type === "support_chat") {
            addUserMessagesNotification(typedPayload);
            addNotRemovedNotifications(typedPayload);
            addUnReadCounter();
            console.log("Data type:", payload.data?.content, "typedPayload");
            toast.custom(t => <div className={`${t.visible ? "animate-enter" : "animate-leave"} max-w-max w-full z-99999 bg-primary/10 border-primary/20  text-primary shadow-lg rounded-2xl pointer-events-auto border`}><div className="p-3"><div className="flex items-center gap-3"><div className="shrink-0"><div className="w-8 h-8 bg-yellow-500/10 rounded-lg flex items-center justify-center"><Image src={NotificationIcon} className="w-4 h-4" alt="notification icon" /></div></div><div className="flex-1 min-w-0"><p className="text-sm font-medium text-white truncate">{payload?.notification?.body || "Messages"}</p><p className="text-xs truncate max-w-xs text-white line-clamp-2 mt-0.5">{payload.data?.content}</p></div><button onClick={() => {
                    toast.dismiss(t.id);
                    setSelectedConversationId(payload?.data?.conversation_id);
                    const parsedNormalUser = parseNormalUser(payload?.data?.normal_user);
                    if (parsedNormalUser) {
                      addUserNotification(parsedNormalUser);
                    } else {
                      console.error("Failed to parse normal_user data, using fallback");
                      addUserNotification({
                        id: null,
                        first_name: "Unknown",
                        last_name: "User",
                        email: "unknown@example.com"
                      });
                    }
                    removeSupportNotifications();
                    setIsMessagesSheetOpen(true);
                  }} className="shrink-0 text-primary-600 text-xs font-medium hover:text-primary-700 transition-colors px-2 py-1 rounded-md hover:bg-primary-50">View</button></div></div></div>, {
              duration: 9000,
              position: "top-center"
            });
          } else {
            addNotification(typedPayload);
            toast.custom(t_0 => <div className={`${t_0.visible ? "animate-enter" : "animate-leave"} max-w-md w-full bg-primary/40 text-white shadow-lg rounded-lg pointer-events-auto flex ring-1 ring-black ring-opacity-5`}><div className="flex-1 w-0 p-4"><div className="flex items-start"><div className="shrink-0 flex items-center"><Image src={NotificationIcon} className="w-6 h-6 text-white" alt="notification icon" /></div><div className="ml-3 flex-1"><p className="text-sm font-medium text-white">{payload?.notification?.title}</p><p className="mt-1 text-sm text-gray-200">{payload?.notification?.body}</p></div></div></div><div className="flex border-l border-primary-600"><button onClick={() => {
                  toast.dismiss(t_0.id);
                }} className="w-full border border-transparent rounded-none rounded-r-lg p-4 flex items-center justify-center text-sm font-medium text-white hover:text-gray-200 focus:outline-none focus:ring-2 focus:ring-primary-600">Dismiss</button></div></div>, {
              duration: 9000,
              position: "bottom-right"
            });
          }
        });
      };
      fireBaseFunction();
    };
    $[0] = addNotRemovedNotifications;
    $[1] = addNotification;
    $[2] = addUnReadCounter;
    $[3] = addUserMessagesNotification;
    $[4] = addUserNotification;
    $[5] = queryClient;
    $[6] = removeSupportNotifications;
    $[7] = setIsMessagesSheetOpen;
    $[8] = setSelectedConversationId;
    $[9] = t0;
  } else {
    t0 = $[9];
  }
  let t1;
  if ($[10] !== addNotRemovedNotifications || $[11] !== addNotification || $[12] !== addUserMessagesNotification || $[13] !== addUserNotification || $[14] !== setIsMessagesSheetOpen || $[15] !== setSelectedConversationId) {
    t1 = [addNotification, addUserMessagesNotification, setSelectedConversationId, setIsMessagesSheetOpen, addUserNotification, addNotRemovedNotifications];
    $[10] = addNotRemovedNotifications;
    $[11] = addNotification;
    $[12] = addUserMessagesNotification;
    $[13] = addUserNotification;
    $[14] = setIsMessagesSheetOpen;
    $[15] = setSelectedConversationId;
    $[16] = t1;
  } else {
    t1 = $[16];
  }
  useEffect(t0, t1);
  let t2;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div><Toaster /></div>;
    $[17] = t2;
  } else {
    t2 = $[17];
  }
  return t2;
};
export default Notification;
function _temp(normalUserData) {
  if (!normalUserData) {
    console.warn("No normal_user data provided");
    return null;
  }
  ;
  try {
    const parsed = JSON.parse(normalUserData);
    console.log("Successfully parsed normal_user:", parsed);
    return parsed;
  } catch (t0) {
    const error = t0;
    console.error("Error parsing normal_user JSON:", error);
    console.error("Raw data:", normalUserData);
    return null;
  }
}
function _temp2(registration) {}
function _temp3(error_0) {
  console.error("SW registration failed:", error_0);
}